import { useState, useEffect, useCallback } from "react";
import { getOrgHierarchy } from "../../api/projectApi";

export default function useOrgHierarchy() {
  const [zonesList, setZonesList] = useState([]);
  const [circlesList, setCirclesList] = useState([]);
  const [districtsList, setDistrictsList] = useState([]);
  const [talukasList, setTalukasList] = useState([]);
  const [divisionsList, setDivisionsList] = useState([]);
  const [subdivisionsList, setSubdivisionsList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHierarchy = useCallback(async () => {
    try {
      const data = await getOrgHierarchy();

      setZonesList(
        (data?.zones || []).map((z) => ({
          code: z.zone_code?.toString(),
          name: z.zone_name?.trim() || "",
        }))
      );

      // keep zone_name on every row so we can filter by it later
      setCirclesList(data?.circles || []);
      setDistrictsList(data?.districts || []);
      setTalukasList(data?.talukas || []);
      setDivisionsList(data?.divisions || []);
      setSubdivisionsList(data?.subdivisions || []);
    } catch (error) {
      console.error("Failed to load organization hierarchy:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHierarchy();
  }, [fetchHierarchy]);

  return { zonesList, circlesList, districtsList, talukasList, divisionsList, subdivisionsList, loading };
}